<template>
  <div>

    <el-dialog
        v-if="currentRow"
        :title="'Behandler ' + currentRow.title + (currentRow.id ? ' bearbeiten' : ' hinzufügen')"
        v-model="showEditForm">
      <el-row class="mt-4">
        <el-col :span="18">
          <h6>Bezeichnung</h6>
          <el-input
              placeholder="Bezeichnung"
              v-model="currentRow.title"></el-input>
        </el-col>
        <el-col :span="5" :offset="1">
          <h6>Kürzel</h6>
          <el-input
              placeholder="Kürzel"
              v-model="currentRow.code"></el-input>
        </el-col>
      </el-row>
      <el-row class="mt-4">
        <el-col :span="12">
          <h6>Vorname</h6>
          <el-input
              placeholder="Vorname"
              v-model="currentRow.firstname"></el-input>
        </el-col>
        <el-col :span="11" :offset="1">
          <h6>Nachname</h6>
          <el-input
              placeholder="Nachname"
              v-model="currentRow.name"></el-input>
        </el-col>
      </el-row>
      <el-row class="mt-4">
        <el-col :span="8">
          <h6>Krebsregister Melde-ID</h6>
          <el-input
            placeholder="Melde-ID"
            v-model="currentRow.cancerregistry_id"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <h6>IKNR</h6>
          <el-input
            placeholder="IKNR"
            v-model="currentRow.iknr"></el-input>
        </el-col>
        <el-col :span="7" :offset="1">
          <h6>LANR</h6>
          <el-input
            placeholder="LANR"
            v-model="currentRow.lanr"></el-input>
        </el-col>
      </el-row>


      <template #footer>
        <el-row>
          <el-col :span="10" class="text-left">
            <el-popconfirm
                v-if="currentRow.id"
                title="Sie möchten diesen Behandler löschen?"
                confirmButtonText='Ja, löschen'
                confirmButtonType="danger"
                cancelButtonText='Nein'
                iconColor="red"
                @confirm="onRowDeleteConfirmed(currentRow)">
              <template #reference>
                <el-button type="danger">Löschen</el-button>
              </template>
            </el-popconfirm>
          </el-col>
          <el-col :span="14" class="dialog-footer text-right">
            <el-button @click="showEditForm = false">Abbrechen</el-button>
            <el-button type="primary" @click="saveRow()">{{(currentRow.id ? ' Speichern' : 'Hinzufügen')}}</el-button>
          </el-col>
        </el-row>

      </template>
    </el-dialog>

    <el-button type="primary" @click="onBtnNewClick" size="mini" icon="el-icon-circle-plus">Behandler hinzufügen</el-button>

    <el-table
        ref="practitionerTable"
        :data="tableData"
        :default-sort = "{prop: 'title', order: 'ascending'}"
        style="width: 100%"
        highlight-current-row
        @row-click="onRowEditClick"
        stripe>
      <el-table-column
          prop="title"
          label="Titel"
          sortable>
      </el-table-column>
      <el-table-column
          width="150">
        <template #default="scope">
          <div class="text-right">
            <el-button size="mini" type="warning" @click="onRowEditClick(scope.row)" icon="el-icon-edit"></el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          width="70">
        <template #default="scope">
          <div class="text-right">
            <el-popconfirm
                :title="'Sie möchten diesen Behandler löschen?'"
                confirmButtonText='Ja, löschen'
                confirmButtonType="danger"
                cancelButtonText='Nein'
                iconColor="red"
                @confirm="onRowDeleteConfirmed(scope.row)">
              <template #reference>
                <el-button size="mini" type="warning" icon="el-icon-delete"></el-button>
              </template>
            </el-popconfirm>

          </div>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
const _ = require('lodash');

export default {
  name: "SettingPractitioner",
  props: [],
  components: {},
  data() {
    return {
      tableData: [],
      currentRow: null,
      showEditForm: false
    }
  },
  mounted: async function () {
    await this.getPractitioner()
  },
  computed: {
    ...mapGetters('practitioner', ['practitioner']),
  },
  watch: {
    practitioner: function (val) {
      this.tableData = _.cloneDeep(val)
    }
  },
  methods: {
    ...mapActions('practitioner', ['getPractitioner', 'deleteDoctor', 'savePractitioner']),
    async onRowDeleteConfirmed(row) {
      await this.deleteDoctor(row)
      this.showEditForm = false
      await this.getPractitioner()
    },
    onBtnNewClick() {
      this.currentRow = {
        id: null,
        title: ''
      }
      this.showEditForm = true

    },
    onRowEditClick(row) {
      this.currentRow = row
      this.showEditForm = true
    },
    async saveRow() {
      await this.savePractitioner(this.currentRow)
      this.showEditForm = false
      await this.getPractitioner()
    }
  }
}
</script>
<style scoped>
</style>
